import { render, staticRenderFns } from "./New.vue?vue&type=template&id=1a659d5f&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=1a659d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a659d5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a659d5f')) {
      api.createRecord('1a659d5f', component.options)
    } else {
      api.reload('1a659d5f', component.options)
    }
    module.hot.accept("./New.vue?vue&type=template&id=1a659d5f&scoped=true&", function () {
      api.rerender('1a659d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Customer/New.vue"
export default component.exports